import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useApiMutation } from '../useApiMutation';
import { leadKeys } from '@/lib/queryKeys';
import { leadEndpoints } from '@/lib/api/endpoints';
import { apiPost, operationsClient } from '@/lib/api';
import type { Lead } from '@/types/lead';

interface ConvertToEstimateResult {
  lead: Lead;
  estimateId: string;
}

export function useConvertToEstimate() {
  const queryClient = useQueryClient();

  return useApiMutation<ConvertToEstimateResult, string>({
    mutationFn: (leadId) =>
      apiPost<ConvertToEstimateResult>(operationsClient, leadEndpoints.convertToEstimate(leadId)),
    onSuccess: (data, leadId) => {
      void queryClient.invalidateQueries({ queryKey: leadKeys.detail(leadId) });
      void queryClient.invalidateQueries({ queryKey: leadKeys.lists() });
      void queryClient.invalidateQueries({ queryKey: leadKeys.pipeline() });
      toast.success('Lead converted to estimate');
    },
  });
}
